import { arrayOf, string } from 'prop-types';
import React, { Component } from 'react';
import { View } from 'react-native';

import { Consumer } from '../../../../context';
import { THEME } from '../../../../reactor/common';
import { Button, Text } from '../../../../reactor/components';
import { Slide } from './components';
import styles from './Slider.style';

const { COLOR } = THEME;

class Slider extends Component {
  static propTypes = {
    images: arrayOf(string),
    texts: arrayOf(string),
  };

  static defaultProps = {
    images: [],
    texts: [],
  };

  state = {
    index: 0,
  }

  componentWillReceiveProps({ images: nextImages = [] }) {
    const { props: { images = [] } } = this;
    if (images.length !== nextImages.length) this.setState({ index: 0 });
  }

  _onIndex = index => this.setState({ index });

  render() {
    const {
      _onIndex,
      props: { images = [], texts = [] },
      state: { index },
    } = this;
    const { length } = images;
    const back = index < 1;
    const next = index >= length - 1;

    return (
      <Consumer>
        { ({ l10n }) => (
          <View style={styles.container}>
            <View>
              { images.map((uri, i) => (
                <Slide
                  key={uri}
                  image={uri}
                  text={texts[i]}
                  visible={i >= index}
                  style={{ zIndex: length - i }}
                />))}
            </View>

            <View style={styles.navigation}>
              <Button contained={false} disabled={back} icon="left" onPress={() => _onIndex(index - 1)} rounded />
              <Text color={COLOR.WHITE}>
                {`${index + 1} ${l10n.OF} ${length}`}
              </Text>
              <Button contained={false} disabled={next} icon="right" onPress={() => _onIndex(index + 1)} rounded />
            </View>
          </View>
        )}
      </Consumer>
    );
  }
}

export default Slider;
